import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "../UI/Button";
import { FaSpinner } from "react-icons/fa";

const CreateGroupModal = ({ callbacks: { createGroup }, closeModal }) => {
  const [checked, setChecked] = useState(false);
  const creatingGroup = useSelector(
    (state) => state.createGroupReducer.loading
  );
  return (
    <>
      <h2 className="form-page-title">Confirm New Network Creation</h2>
      <div className="form-body-container">
        <p className="warning-body">
          You are about to create your own network.
          <br />
          <br />
          Creating a network will make you the sole member of this network and
          associate all of your cases to it. If you later leave this network,
          your cases will remain as a part of the network and you will{" "}
          <b>NOT</b> have access to them.
          <br />
          <br />
          Click "Confirm" to create a new network
        </p>

        <div className="checkbox-container">
          <input
            type="checkbox"
            onChange={() => setChecked(!checked)}
            checked={checked}
            id="acknowledgement"
            className="usa-checkbox__input"
          />
          <label className="usa-checkbox__label" htmlFor="acknowledgement">
            Acknowledge
          </label>
        </div>

        <div className="form-buttons">
          <Button coloring="outline" onClick={closeModal}>
            Cancel
          </Button>
          <Button onClick={createGroup} disabled={!checked}>
            {!!creatingGroup && <FaSpinner className="icon-spin" />}Confirm
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateGroupModal;
